import React, { useState, useContext, useId } from "react";
import "../../style.css";
import axios from "axios";
// import ModelView from "../collection/ModelView"
//import Pagination from "../../components/Pagination";
// import DomainDropdown from "../../components/DomainDropdownFilter";
// import Search from "../../components/Search";
import ContentFetchTable from "./ContentFetchTable";
import { GlobalContext } from '../../context/GlobalContext';
import Popup from "../popup/Popup";
import PaginationModule from "../../pagination/PaginationModule";
import DomainFilter from "../../components/DomainFilter";
import { toast } from "react-toastify";

const Contents = () => {
  const generatedId = useId();
  const selectId = `rawcontents-${generatedId}`;
  const { API_URL } = useContext(GlobalContext);
  // const [filterData, setFilterData] = useState([]);
  const [DomainData, setDomainData] = useState([]);
  const [filterDomainData, setFilterDomainData] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  // const [selectedDomain, setSelectedDomain] = useState("");

  // eslint-disable-next-line
  const [selectAll, setSelectAll] = useState(false);
  const [transferData, setTransferData] = useState("");
  const [message, setMessage] = useState(false);

  // Get current posts
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage, setPostsPerPage] = useState(10);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filterDomainData.slice(indexOfFirstPost, indexOfLastPost);
  const howManyPages = Math.ceil(filterDomainData.length / postsPerPage);

  const [selectedDomain, setSelectedDomain] = useState("");
  const [selectedURL, setSelectedURL] = useState("");


  const handleCheckboxChange = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };


  const Transfer = async () => {
    if (selectedIds.length === 0) return;

    const selectedData = DomainData.filter((item) => selectedIds.includes(item.id));
    console.log("selectedData: ", selectedData);

    const toastId = toast.loading("Data processing, please wait...");
    try {
      // eslint-disable-next-line
      const response = await axios.post(`${API_URL}/TransferData`,
        {
          domain: selectedDomain,
          records: selectedData,
        });

      if (response.status === 200) {
        setTransferData(response.data)
        toast.update(toastId, {
          render: "Data transferred successfully.",
          type: "success",
          isLoading: false,
          autoClose: 3000,
          closeOnClick: true,
          draggable: true,
          closeButton: true
        });
      }

      const resetData = DomainData.map((item) => {
        if (selectedIds.includes(item.id)) {
          return {
            ...item,
            checked: false,
          };
        }
        return item;
      });

      const resetFilterData = filterDomainData.map((item) => {
        if (selectedIds.includes(item.id)) {
          return {
            ...item,
            checked: false,
          };
        }
        return item;
      });

      setDomainData(resetData);
      setFilterDomainData(resetFilterData);
      setSelectedIds([]);
      setMessage(false);
      setShowAlert(true);
    } catch (error) {
      console.log(error);
      toast.update(toastId, {
        render: "Failed to transfer data. Please try again.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const handleSelectAll = () => {
    const currentPageIds = currentPosts.map(item => item.id);
    const allSelected = currentPageIds.every(id => selectedIds.includes(id));

    if (allSelected) {
      // If all are selected, unselect all
      setSelectedIds(selectedIds.filter(id => !currentPageIds.includes(id)));
    } else {
      // If not all are selected, select all
      setSelectedIds([...selectedIds, ...currentPageIds]);
    }
  };

  // eslint-disable-next-line
  const handleRemoveText = (indexToRemove) => {
    setSelectedIds((prevSelectedIds) => {
      // Create a new array without the item at the specified index
      const updatedSelectedIds = prevSelectedIds.filter((_, index) => index !== indexToRemove);
      return updatedSelectedIds;
    });
  };

  const checkAll = () => {
    const confirmCheckAll = window.confirm("Are you sure you want to check all data for transfer?");

    if (confirmCheckAll) {
      const currentPageIds = filterDomainData.map(item => item.id);
      const allSelected = currentPageIds.every(id => selectedIds.includes(id));

      if (allSelected) {
        setSelectedIds(selectedIds.filter(id => !currentPageIds.includes(id)));
      } else {
        setSelectedIds([...selectedIds, ...currentPageIds]);
      }
    }
  };


  return (
    <>
      <div className="container mb-2">
        <div className="row align-items-center">
          <div className="col-md-8 px-0 py-0">
            <DomainFilter
              setData={setDomainData}
              setFilterData={setFilterDomainData}
              selectedDomain={selectedDomain}
              setSelectedDomain={setSelectedDomain}
              selectedURL={selectedURL}
              setSelectedURL={setSelectedURL}
            />
          </div>

          <div className="col-md-1 px-0 py-0">
            {selectedDomain ?
              <button id={`${selectId}-checkAll`} className="btn btn-light border py-2" onClick={checkAll}>Check All</button>
              : ""}
          </div>
          <div className="col-md-2">
            {selectedIds.length > 0 && (
              <button className="btn btn-light border text-danger ms-1">Selected: {selectedIds.length}</button>
            )}
          </div>

        </div>
      </div>

      <div className="container ms-3 mb-2">
        <div className="d-flex justify-content-end">
          {selectedIds.length > 0 && (
            <div className="d-flex justify-content-end">
              {/* <button className="btn btn-light border" onClick={MergedHandle}>Merged Transfer</button> */}
              <button id={`${selectId}-transfer`} className="btn btn-light border py-2 px-2 fs-5" onClick={Transfer}>Transfer to Source</button>
              <button id={`${selectId}-clear`} className="btn btn-light border ms-1 py-2 px-2 fs-5" onClick={() => setSelectedIds([])}>Clear</button>
              {/* <button id={`${selectId}-selected`} className="btn btn-light border text-danger ms-1 py-2 px-2 fs-5">Selected: {selectedIds.length}</button> */}
              {/* <ModelView data={DomainData} selectedIds={selectedIds} handleRemoveText={handleRemoveText} /> */}
            </div>
          )}
        </div>
      </div>

      <div className="">
        {message && (
          <Popup setOpenModal={setMessage} message="Data processing, please wait..." />)}
      </div>

      {showAlert && transferData?.message && (
        <div
          className="alert alert-success alert-dismissible fade show shadow-sm border-0 rounded-3 p-3 position-relative"
          role="alert"
        >
          <div className="d-flex align-items-start pe-4">
            <div className="flex-grow-1">
              {String(transferData.message)
                .split("\n")
                .map((line, index) => (
                  <div key={index} className="mb-1">
                    {line}
                  </div>
                ))}
            </div>
          </div>

          <button
            type="button"
            className="btn-close position-absolute top-0 end-0 m-3"
            aria-label="Close"
            onClick={() => setShowAlert(false)}
          />
        </div>
      )}

      {currentPosts.length > 0 ? (
        <div className="container-fluid mb-2">
          <ContentFetchTable
            selectId={selectId}
            currentPosts={currentPosts}
            handleCheckboxChange={handleCheckboxChange}
            setFilterData={setFilterDomainData}
            filterData={filterDomainData}
            setData={setDomainData}
            selectedIds={selectedIds}
            selectAll={selectAll}
            handleSelectAll={handleSelectAll}
          />
        </div>
      ) : (
        <div className="container-fluid text-center fs-4 py-4 text-muted border">
          Apply filters to view the data.
        </div>
      )}

      <div className="">
        <PaginationModule totalPages={howManyPages} postsPerPage={postsPerPage} setPostsPerPage={setPostsPerPage} currentPage={currentPage} setCurrentPage={setCurrentPage} />
      </div>

    </>
  );
};

export default Contents;
